import type { PlanClaim, PlanRepair } from '../api.ts';
import * as wording from '../wording.ts';

/**
 * The plan's `## Claims` (the ad bible US-014): one row per claim the ad
 * makes, with its kind, source, scope, permission and status, and below it
 * whatever the ledger does not back yet. A record, like the decisions: the
 * repairs are the planner's, and nothing here waits on the operator.
 */
export function Claims({
  claims,
  repairs,
}: {
  readonly claims: readonly PlanClaim[];
  readonly repairs: readonly PlanRepair[];
}) {
  if (claims.length === 0 && repairs.length === 0) return null;
  return (
    <section className="claims-ledger" aria-label={wording.CLAIMS_TITLE}>
      <strong>{wording.CLAIMS_TITLE}</strong>
      <p className="field__hint">{wording.CLAIMS_HINT}</p>
      {claims.length > 0 && (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Claim</th>
                <th scope="col">Kind</th>
                <th scope="col">Source</th>
                <th scope="col">Scope</th>
                <th scope="col">Permission</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {claims.map((claim) => (
                <tr key={claim.line}>
                  <td>{claim.claim}</td>
                  <td>{claim.kind}</td>
                  <td>{claim.source}</td>
                  <td className="muted">{claim.scope}</td>
                  <td>{claim.permission}</td>
                  <td>{claim.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {repairs.length > 0 && (
        <div className="plan-problems plan-problems--warn">
          <p className="plan-problems__title">{wording.CLAIMS_REPAIRS}</p>
          <ul className="plan-problems__list">
            {repairs.map((repair, position) => (
              <li key={`${String(repair.line)}-${String(position)}`}>
                {repair.line > 0 && <span className="plan-problems__line mono">line {repair.line}</span>}
                {repair.message}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
